import React from 'react';
import '../../global.css';

const CustomBlueButton = (props) => {
    return (
        <div>
            <button className={`customCreateButton ${props.customCreatePropsBtnClass}  ${props.disabled ? 'opacityHalf cursorNotAllowed' : ''}`}
                onClick={props.onClick} disabled={props.disabled}>
                {props.title}
            </button>
        </div>
    )
}

export default CustomBlueButton